import { useNavigate } from "react-router-dom";
import { Bell, ChevronLeft, LogOut, User } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function AppTopBar({ title = "", showBack = false, hideRight = false }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <header
      className="sticky top-0 z-40 bg-white/85 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-[hsl(var(--border))]"
      data-testid="app-topbar"
    >
      <div className="max-w-[520px] mx-auto h-14 flex items-center justify-between px-3">
        <div className="flex items-center gap-2 min-w-0">
          {showBack ? (
            <button
              onClick={() => navigate(-1)}
              className="p-2 rounded-lg hover:bg-[hsl(var(--secondary))]"
              aria-label="Voltar"
              data-testid="topbar-back"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
          ) : (
            <Logo size={28} showText={!title} />
          )}
          {title && (
            <h1 className="font-display font-semibold text-base text-[hsl(var(--primary))] truncate" data-testid="topbar-title">
              {title}
            </h1>
          )}
        </div>
        {!hideRight && (
          <div className="flex items-center gap-1">
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={() => navigate("/notificacoes")}
              aria-label="Notificações"
              data-testid="topbar-notifications"
            >
              <Bell className="w-5 h-5" />
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="h-9 w-9" data-testid="topbar-user-menu">
                  <User className="w-5 h-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel className="truncate">{user?.full_name || "Usuário"}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => navigate("/perfil")} data-testid="menu-perfil">
                  <User className="w-4 h-4 mr-2" /> Meu perfil
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/carteira")} data-testid="menu-carteira">Carteira digital</DropdownMenuItem>
                <DropdownMenuItem onClick={() => navigate("/certificados")} data-testid="menu-certificados">Meus certificados</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => { logout(); navigate("/login"); }} data-testid="menu-logout">
                  <LogOut className="w-4 h-4 mr-2" /> Sair
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
    </header>
  );
}
